import { useRouter } from 'next/router';
import ArticleSubscriptionsContextProvider, {
  useArticlesSubscriptionsContext,
} from '@/finsight/application/CreditFlowResearch/ArticlesSubscriptions';
import { usePageFiltersContext } from '@/finsight/application/PageFilters/PageFiltersContext';
import capitalize from '@/Framework/dataHelpers/string/capitalize';
import { mapArticleTypeToTitle } from '@/finsight/ui/components/creditFlow/articles/constants';
import { getLabel } from './helpers';
import SubscribeButton from 'src/finsight/ui/components/creditFlow/articles/common/SubscribeButton';
import { useUserSubscriptionsContext }
  from '@/finsight/application/Subscriptions/UserSubscriptionsContext/UserSubscriptionsContext';
import { USOA_REGION_ID } from '@/finsight/domain/Region';

const TileSubscribeButton = ({ themeType }) => {
  const {
    productFilters,
    regionFilters,
    pageFilters: {
      productIds,
      regionIds,
      sector,
      industry,
    },
    company,
  } = usePageFiltersContext();
  const {
    isSubscribed,
    onSubscribe,
    isOneFilterSelected,
    isFetching,
    isCommonButtonUsed,
  } = useArticlesSubscriptionsContext();
  const { isCommonButtonSubscribed } = useUserSubscriptionsContext();
  const { query: { sector: isSectorPage, industry: isIndustryPage, companyViewId } } = useRouter();

  const { marketDataName } = productFilters.find(({ id }) => id === productIds[0]);
  const { shortDisplayName, id, abbreviation } = regionFilters.find(({ id }) => id === regionIds[0]);

  const getName = () => {
    if (companyViewId) {
      return company.name;
    }
    if (isSectorPage) {
      return sector.pageTitleName;
    }
    if (isIndustryPage) {
      return industry.pageTitleName;
    }
    return marketDataName;
  };
  const isButtonSubscribed = isCommonButtonUsed ? isCommonButtonSubscribed : isSubscribed;

  const label = getLabel({
    isOneFilterSelected,
    isSubscribed: isButtonSubscribed,
    shortDisplayName: id === USOA_REGION_ID ? shortDisplayName : abbreviation,
    name: getName(),
    articleType: mapArticleTypeToTitle[themeType],
    isCompanyPage: !!companyViewId,
  });

  const isDisabled = isButtonSubscribed || (!companyViewId && !isOneFilterSelected);

  return (
    <SubscribeButton
      tooltip={ label }
      onClick={ onSubscribe }
      isDisabled={ isDisabled }
      isFetching={ isFetching }
      isSubscribed={ isButtonSubscribed }
      dataTest={ `subscribeButton${ capitalize(themeType) }` }
    />
  );
};

export default ({ themeType }) => (
  <ArticleSubscriptionsContextProvider themeType={ themeType }>
    <TileSubscribeButton themeType={ themeType } />
  </ArticleSubscriptionsContextProvider>
);
